import { FC } from "react";
import useEdit from "./hook";
import { Styles } from "./styled";
import EditPage from "@lhd/components/CloneApp/pages/EditPage";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";

const EditLayout = (props: ReturnType<typeof useEdit>) => {
  const { permissionItem } = props;
  return (
    <Styles>
      <EditPage
        appType={APP_TYPES.FINANCIAL_REPORTS}
        permission={permissionItem}
        showPrintButton
        configShowBtnsOnHeader={{
          btnSave: true,
          btnPreview: true,
          btnDuplicate: true,
          btnToCreate: true,
          saveAsNew: true,
          btnPrintPdf: true,
        }}
        hasControlPageMode
      />
    </Styles>
  );
};

const Edit: FC = () => <EditLayout {...useEdit()} />;

export default Edit;
